import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _typeof from "@babel/runtime/helpers/typeof";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import $ from '@sparta.global.vendors/jquery';
import _ from '@sparta.global.vendors/lodash';
function isObject(value) {
  var type = _typeof(value);
  return value != null && (type === 'object' || type === 'function');
}
/*
  Example:
  const obj = { a: 1, b: { c: 2 } };
  const updatedObj = immutableSet(obj, 'b.c', 4);
  ==> { a: 1, b: { c: 4 } }
  const updatedObj = immutableSet(obj, 'b', { d: 1 })
  ==> { a: 1, b: { d: 1 } }
*/
function immutableSet(object, location, value) {
  if (!isObject(object)) {
    return object;
  }
  var path = location.split('.');
  var length = path.length;
  var lastIndex = length - 1;
  var index = 0;
  var updatedObject = JSON.parse(JSON.stringify(object));
  var nested = updatedObject;
  while (nested !== null && index < length) {
    var key = path[index];
    var newValue = value;
    if (index !== lastIndex) {
      var objValue = nested[key];
      if (isObject(objValue)) {
        newValue = objValue;
      } else {
        newValue = typeof path[index + 1] === 'undefined' ? [] : {};
      }
    }
    nested[key] = newValue;
    nested = newValue;
    index += 1;
  }
  return updatedObject;
}
function immutableSetMultiple(object, updates) {
  function reducer(memo, key) {
    return immutableSet(memo, key, updates[key]);
  }
  return Object.keys(updates).reduce(reducer, object);
}
var staticOptions = {
  immutableSet: immutableSet,
  immutableSetMultiple: immutableSetMultiple
};
function groupByName(items) {
  function reducer(accumulator, item) {
    var name = item.name,
      value = item.value;
    if (accumulator[name]) {
      if (Array.isArray(accumulator[name])) {
        return _objectSpread(_objectSpread({}, accumulator), {}, _defineProperty({}, name, [].concat(_toConsumableArray(accumulator[name]), [value])));
      }
      return _objectSpread(_objectSpread({}, accumulator), {}, _defineProperty({}, name, [accumulator[name], value]));
    }
    return _objectSpread(_objectSpread({}, accumulator), {}, _defineProperty({}, name, item.value));
  }
  return items.reduce(reducer, {});
}
function getFormValues($form) {
  return groupByName($form.serializeArray());
}
function injectPrefillValues(form, values) {
  var formValues = _.fromPairs(_.compact(Object.keys(form).map(function (key) {
    var field = form[key];
    var value = values[key];
    if (field.radioButtons && !_.isNull(value) && !_.isUndefined(value)) {
      var fieldWithValue = _objectSpread(_objectSpread({}, field), {}, {
        radioButtons: field.radioButtons.map(function (item) {
          return item.radioButton.attrs.value !== value.toString() ? item : _objectSpread(_objectSpread({}, item), {}, {
            radioButton: _objectSpread(_objectSpread({}, item.radioButton), {}, {
              attrs: _objectSpread(_objectSpread({}, item.radioButton.attrs), {}, {
                checked: true
              })
            })
          });
        })
      });
      return [key, fieldWithValue];
    }
    if (field.checkboxes) {
      if (!_.isEmpty(value)) {
        // We found a value match for the checkbox group parent
        var _fieldWithValue;
        if (Array.isArray(value)) {
          _fieldWithValue = _objectSpread(_objectSpread({}, field), {}, {
            checkboxes: field.checkboxes.map(function (item) {
              var isPresent = value.indexOf(item.checkbox.attrs.value) !== -1 || value.indexOf(item.checkbox.attrs.id) !== -1;
              return !isPresent ? item : _objectSpread(_objectSpread({}, item), {}, {
                checkbox: _objectSpread(_objectSpread({}, item.checkbox), {}, {
                  attrs: _objectSpread(_objectSpread({}, item.checkbox.attrs), {}, {
                    checked: true
                  })
                })
              });
            })
          });
        } else {
          _fieldWithValue = _objectSpread(_objectSpread({}, field), {}, {
            checkboxes: field.checkboxes.map(function (item) {
              return _objectSpread(_objectSpread({}, item), {}, {
                checkbox: _objectSpread(_objectSpread({}, item.checkbox), {}, {
                  attrs: _objectSpread(_objectSpread({}, item.checkbox.attrs), {}, {
                    checked: true
                  })
                })
              });
            })
          });
        }
        return [key, _fieldWithValue];
      }
      // We should still try to match up individual checkboxes
      // in the group with values in the response
      var fieldWithValues = _objectSpread(_objectSpread({}, field), {}, {
        checkboxes: field.checkboxes.map(function (item) {
          var itemName = item.checkbox.attrs.name;
          var itemValue = item.checkbox.attrs.value;
          value = values[itemName] && values[itemName].toString() || values[itemValue] && values[itemValue].toString();
          return !value ? item : _objectSpread(_objectSpread({}, item), {}, {
            checkbox: _objectSpread(_objectSpread({}, item.checkbox), {}, {
              attrs: _objectSpread(_objectSpread({}, item.checkbox.attrs), {}, {
                checked: true
              })
            })
          });
        })
      });
      return [key, fieldWithValues];
    }
    if (field.select && field.select.options && value) {
      var _fieldWithValue2 = _objectSpread(_objectSpread({}, field), {}, {
        select: _objectSpread(_objectSpread({}, field.select), {}, {
          options: field.select.options.map(function (option) {
            return option.value !== (value && value.toString()) ? option : _objectSpread(_objectSpread({}, option), {}, {
              selected: true
            });
          })
        })
      });
      return [key, _fieldWithValue2];
    }
    if (field.datepicker && value) {
      var _fieldWithValue3 = _objectSpread(_objectSpread({}, field), {}, {
        datepicker: _objectSpread(_objectSpread({}, field.datepicker), {}, {
          attrs: _objectSpread(_objectSpread({}, field.datepicker.attrs), {}, {
            value: value
          })
        })
      });
      return [key, _fieldWithValue3];
    }
    if (field.input && value) {
      var _fieldWithValue4 = _objectSpread(_objectSpread({}, field), {}, {
        input: _objectSpread(_objectSpread({}, field.input), {}, {
          attrs: _objectSpread(_objectSpread({}, field.input.attrs), {}, {
            value: value
          })
        })
      });
      return [key, _fieldWithValue4];
    }
    if (key.includes('Prefill')) {
      var element = key.split('Prefill')[0];
      value = values[element];
      var updatedValue = !!(typeof value !== 'undefined' && value !== null);
      return [key, updatedValue];
    }
    return [key, field];
  })));
  return _.defaultsDeep({}, formValues, form);
}
function formatForm(formToFormat) {
  var finalForm = _.fromPairs(Object.keys(formToFormat).map(function (key) {
    var field = formToFormat[key];
    var extended = _typeof(field) === 'object' ? _objectSpread({}, field) : field;
    var hasInput = extended && extended.input;
    var hasValue = hasInput && extended.input.attrs.value;
    var hasCurrency = hasInput && extended.input.format && extended.input.format.includes('currency');
    if (hasValue && hasCurrency && typeof extended.input.attrs.value === 'string') {
      var currency = extended.input.attrs.value;
      var fractionAndValue = currency.split('.');
      var value = fractionAndValue[0];
      var fraction = fractionAndValue[1] || '';
      if (fraction === '0' || fraction === '00') {
        extended.input.attrs.value = value;
      } else if (fraction && fraction.length === 1) {
        fraction = parseInt(fractionAndValue[1], 10);
        fraction *= 10;
        extended.input.attrs.value = "".concat(value, ".").concat(fraction);
      }
    }
    return [key, extended];
  }));
  return finalForm;
}
function toCurrency(num) {
  if (num == null) return '0.00';
  var sign = /^\s*-/.test(num) ? '-' : '';
  var transformedNum = num;
  if (typeof num === 'string') {
    transformedNum = Number(num.replace(/[^0-9.]+/g, ''));
  } else if (typeof num === 'number') {
    transformedNum = Math.abs(num);
  } else {
    transformedNum = 0;
  }
  var magnitude = transformedNum.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
  return "".concat(sign).concat(magnitude);
}

/**
 * Hide/Show the 'None of these apply' checkbox on the basis of other checkbox status
 * it is optional to pass the ID, by default it will take id of last checkbox element
 * @param {String} wrapper
 * @param {String} id
 * e.g. wrapper is class for div element, where handlebar helper for the checkbox group is defined
 * <div class="">\{{{ checkbox }}}</div>
 */
function toggleNoOtherOptionsCheckbox(wrapper, id) {
  var checkboxesList = document.querySelectorAll(".".concat(wrapper, " input[type=checkbox]"));
  var targetEleId = id || _.last(checkboxesList).id;
  var targetEle = document.getElementById(targetEleId);

  //  create filtered checkbox list without none checkbox
  var filteredCheckboxList = _.filter(checkboxesList, function (checkbox) {
    return checkbox.id !== targetEleId;
  });
  function getStatus(checkboxList) {
    return _.map(checkboxList, function (item) {
      return item.checked && item.offsetHeight > 0;
    });
  }
  function toggleCheckbox() {
    if (getStatus(filteredCheckboxList).includes(true)) {
      targetEle.checked = false; // Un-check the none checkbox
      if (!targetEle.parentElement.className.includes('hide')) {
        targetEle.parentElement.className += ' hide'; // Hide the None checkbox
      }
    } else {
      targetEle.parentElement.className = targetEle.parentElement.className.replace(/ hide/g, ''); // Show the none checkbox
    }
  }

  // Define 'change' event on each checkbox
  filteredCheckboxList.forEach(function (checkbox) {
    checkbox.addEventListener('change', toggleCheckbox, false);
  });
  toggleCheckbox();
}
function hideInputsRow($row) {
  $row.addClass('hide');
  $('input,select', $row).attr('disabled', true);
  $row.find('label').not('.spa-input-option-label') // Ensures checkboxes/radio button labels are not selected
  .addClass('spa-input-label--disabled').removeClass('spa-input-label');
  $row.find('i.datepicker-icon--calendar').addClass('datepicker-icon--calendar__disabled');
}
function showInputsRow($row) {
  $row.removeClass('hide');
  $('input,select', $row).attr('disabled', false);
  $row.find('label').not('.spa-input-option-label') // Ensures checkboxes/radio button labels are not selected
  .removeClass('spa-input-label--disabled').addClass('spa-input-label');
  $row.find('i.datepicker-icon--calendar').removeClass('datepicker-icon--calendar__disabled');
  // Re-initializes sparta inputs
  // (Due to V6 Global Sparta Change dynamically assigning currency values).
  $row.spartaInputs();
}
function postRenderLogic(formContext, copy, state, response, dataSource, routeName) {
  var currentRoute = copy[dataSource] && copy[dataSource].routes ? copy[dataSource].routes[routeName] : routeName;
  var jcr = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, copy[dataSource]), state), response), {}, {
    currentRoute: currentRoute
  }, formContext);
  var form = jcr.form,
    forms = jcr.forms;
  var formattedForm = {};
  if (form) {
    formattedForm.form = formatForm(form);
  } else {
    formattedForm.forms = forms.map(function (value) {
      return formatForm(value);
    });
  }
  var finalJCR = _objectSpread(_objectSpread({}, jcr), formattedForm);
  return finalJCR;
}
function selectElementContents(el) {
  var range = document.createRange();
  range.selectNodeContents(el);
  var sel = window.getSelection();
  sel.removeAllRanges();
  sel.addRange(range);
}
function deselectAll() {
  var element = document.activeElement;
  if (element && /INPUT|TEXTAREA/i.test(element.tagName)) {
    if ('selectionStart' in element) {
      element.selectionEnd = element.selectionStart;
    }
    element.blur();
  }
  if (window.getSelection) {
    // All browsers, except IE <=8
    window.getSelection().removeAllRanges();
  } else if (document.selection) {
    // IE <=8
    document.selection.empty();
  }
}
var index = {
  injectPrefillValues: injectPrefillValues,
  getFormValues: getFormValues,
  toCurrency: toCurrency,
  toggleNoOtherOptionsCheckbox: toggleNoOtherOptionsCheckbox,
  immutableSet: staticOptions.immutableSet,
  immutableSetMultiple: staticOptions.immutableSetMultiple,
  hideInputsRow: hideInputsRow,
  showInputsRow: showInputsRow,
  formatForm: formatForm,
  postRenderLogic: postRenderLogic,
  selectElementContents: selectElementContents,
  deselectAll: deselectAll
};
export { index as default };